<template>
    <div class="course_side_content_div">
        <div class="course_base_info_and_feature_div">
            <!-- 
                img
                type
                join in button
                task
                challanges
                hr
                follow
             -->
            <img class="course_info_img" :src="course_info.picture_url">
            <CourseTeacher></CourseTeacher>
            <!--<img class="course_info_img" :src="course_info.teacher.avatar_url">-->
            <!--<div v-html="course_info.teacher.teacher_info.description.replace(/\n/g,'<br/>')"></div>-->
            <div v-if="course_info.fee_type === 'paid' && course_info.code !== 'not_published'" class="course_info_box">
                <span class="bootcamp_price" v-if="course_info.price>0">
                    <span style="font-size: 14px">{{course_info.price_name}}</span>￥{{ course_info.price }}
                </span>
                <span class="bootcamp_price" style="text-decoration: line-through;color: lightsteelblue"
                      v-if="course_info.real_price>0">
                    ￥{{ course_info.real_price }}
                </span>
            </div>

            <div class="course_info_box" v-if="course_info.code !== 'not_published'">
                <!--
                   训练营的课程内容会显示
                   价格
                   免费 高级会员
                     打折后的钱 标准会员
                   开通高级会员免费学 链接
                 -->

                <p v-if="course_info.fee_type !== 'bootcamp'">{{ fee_type_dict[course_info.fee_type] }}</p>
                <div v-if="course_info.fee_type == 'bootcamp'" class="bootcamp_info_layout">
                    <p class="bootcamp_price">
                        ￥ {{ course_info.real_price }}
                    </p>
                    <div class="member_dict_layout">
                        免费 <img src="https://static.shiyanlou.com/frontend/dist/img/eb8486c.png">
                        <i class="fas fa-angle-down bootcamp_angle"></i>
                        <div class="member_price_card">
                            ￥ {{ course_info.real_price * 0.8 }} <img
                                src="https://static.shiyanlou.com/frontend/dist/img/3ee60d7.png">
                        </div>
                    </div>
                    <div class="bootcamp_member_info">
                        <span>开通高级会员，立享免费学</span>
                        <a href="https://www.shiyanlou.com/vip" target="_blank" class="go_for_purchase">去开通</a>
                    </div>
                </div>
                <!-- 这边之后会根据不同的 fee_type 和 userstatus_info 的 status 进行不同的展示，
                     目前已知的:
                     1. 加入会员免费学.
                     2. 训练营的需要额外付费或者开通高级会员.
                     3. 免费的加入课程.
                     4. 已经加入课程后显示继续学习

                     登录和不登录状态下的变化:
                     登录状态下:
                         根据不同的类型:
                            1. 非会员:
                               1. 免费 -> 加入课程
                               2. 会员 -> 加入会员学习
                               3. 训练营 -> 显示购买价格 以及 高级会员免费学。
                            2.
                               会员状态下可学习的应该全都是 加入课程。
                     非登录状态下:
                         1. 免费 -> 原站是 ·立即购买·，这里应该是写错了吧。
                         2. 会员 -> 加入会员学习。
                         3. 训练营 -> 显示购买价格 以及 高级会员免费学。
                 -->
                <div v-if="sign_on==false">
                    <div v-if="course_info.is_active">
                        <button class="btn course_side_base_btn join_in_course_button"
                                v-if="course_info.fee_type==='free'"
                                @click="show_login('on')"
                        >加入课程
                        </button>
                        <a href="/vip" target="_blank" class="btn course_side_base_btn join_member_button"
                           v-if="course_info.fee_type==='member'"
                        >加入会员免费学
                        </a>
                        <button class="btn course_side_base_btn buy_course_button"
                                v-if="course_info.fee_type==='bootcamp' || course_info.fee_type==='paid'"
                                @click="show_login('on')"
                        >立即购买
                        </button>

                    </div>
                    <div v-else>
                        <button class="btn course_side_base_btn apply_course_button"
                                @click="show_login('on')"
                        >立即报名
                        </button>
                    </div>
                    <button class="btn course_side_base_btn buy_course_button"
                                style="margin-top: 10px;margin-bottom: 10px"
                                v-if="course_info.fee_type==='paid' && userstatus_info.is_business && !userstatus_info.group_buy_id"
                                @click="start_group_buy(course_info.id)"
                        >发起拼团
                    </button>
                    <button class="btn course_side_base_btn buy_course_button"
                                style="margin-top: 10px;margin-bottom: 10px"
                                v-if="course_info.fee_type==='paid' && userstatus_info.is_business && userstatus_info.group_buy_id"
                                @click="start_group_buy(course_info.id)"
                        >我的拼团
                    </button>
                </div>
                <div v-else>
                    <el-dialog :modal-append-to-body='false'
                               :visible.sync="dialogVisible"
                               width="30%">
                        <ul class="nav_title_ul" style="margin-top: -40px">
                            <li class="nav_title_li"
                                :class="nav_title==='购买' ? 'active_nav' : ''"
                                @click="tab_nav('购买')"
                            >
                                购买
                            </li>
                            <li class="nav_title_li"
                                :class="nav_title==='充值' ? 'active_nav' : ''"
                                @click="tab_nav('充值')"
                            >
                                充值
                            </li>
                        </ul>
                        <div class="stuff_div">
                            <keep-alive>
                                <component :is="stuff_component_dict[nav_title]" :data="course_info"
                                           :user_item_id="user_course_id" :type="'ujoyer.course.course'"
                                           :all_need_count="course_info.price * 100"
                                           :recharge_amount="course_info.price"></component>
                            </keep-alive>
                        </div>
                        <!--<span slot="footer" class="dialog-footer">-->
                        <!--<span v-if="nav_title==='购买'" style="font-size: 27px;float: left">购买：{{course_info.name}}</span>-->
                        <!--<span v-if="nav_title==='充值'" style="font-size: 27px;float: left">付款：<span style="color: red">￥399</span></span>-->
                        <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
                        <!--<el-button type="primary" @click="confirm_buy(course_info,user_all_copper_count,expense_all_copper_count,need_count)"-->
                        <!--:disabled="user_all_copper_count<expense_all_copper_count">确 定</el-button>-->
                        <!--</span>-->
                    </el-dialog>
                    <div v-if="course_info.is_active">
                        <button class="btn course_side_base_btn join_in_course_button"
                                v-if="(course_info.fee_type==='free' ||
                                    (course_info.fee_type==='member' && (user_info.member_type == 'plus' || user_info.member_type == 'premium')) ||
                                    (course_info.fee_type==='bootcamp' && user_info.member_type == 'premium') )
                                   && userstatus_info.status!=='active'"
                                @click="join_course()"
                        >加入课程
                        </button>
                        <!--<el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button>-->


                        <button class="btn course_side_base_btn buy_course_button"
                                v-if="(course_info.fee_type==='paid' ||
                                    (course_info.fee_type==='member' && (user_info.member_type == 'plus' || user_info.member_type == 'premium')) ||
                                    (course_info.fee_type==='bootcamp' && user_info.member_type == 'premium') )
                                   && userstatus_info.status!=='active'"
                                @click="to_buy(course_info.id)"
                        >立即购买
                        </button>

                        <a href="/vip" target="_blank" class="btn course_side_base_btn join_member_button"
                           v-if="(course_info.fee_type==='member' && user_info.member_type == null)
                                   && userstatus_info.status!=='active'"
                        >加入会员免费学
                        </a>
                        <button class="btn course_side_base_btn buy_course_button"
                                v-if="(course_info.fee_type==='bootcamp' && user_info.member_type != 'premium')
                                   && userstatus_info.status!=='active'"
                        >立即购买
                            <!-- @click="join_course()" -->
                        </button>
                    </div>
                    <div v-else>
                        <button v-if="!is_applyed" class="btn course_side_base_btn apply_course_button" style=""
                                @click="_apply_course('apply')"
                        >立即报名
                        </button>
                    </div>
                    <button class="btn course_side_base_btn buy_course_button"
                                style="margin-top: 10px;margin-bottom: 10px"
                                v-if="course_info.fee_type==='paid' && userstatus_info.is_business && !userstatus_info.group_buy_id"
                                @click="start_group_buy(course_info.id)"
                        >发起拼团
                    </button>
                    <button class="btn course_side_base_btn buy_course_button"
                                style="margin-top: 10px;margin-bottom: 10px"
                                v-if="course_info.fee_type==='paid' && userstatus_info.is_business && userstatus_info.group_buy_id"
                                @click="start_group_buy(course_info.id)"
                        >我的拼团
                    </button>
                    <el-dialog title="填写信息" :modal-append-to-body='false' :visible.sync="dialogFormVisible" width="30%">
                        <el-form :model="form" ref="form" :rules="rules">
                            <el-form-item label="真实姓名" :label-width="formLabelWidth" prop="realname">
                                <el-input v-model="form.realname" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
                                <el-input v-model="form.phone" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="单位名称" :label-width="formLabelWidth" prop="company">
                                <el-input v-model="form.company" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="岗位名称" :label-width="formLabelWidth" prop="job">
                                <el-input v-model="form.job" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="微信号" :label-width="formLabelWidth">
                                <el-input v-model="form.wechat_number" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取消</el-button>
                            <el-button type="primary" @click="apply_course('apply')">下一步
                            </el-button>
                        </div>
                    </el-dialog>

                </div>
                <div v-if="course_info.is_active && course_info.code !== 'not_published'">
                    <!--<a :href="'/test_socket/'+userstatus_info.last_learned_lesson_id "-->
                    <!--target='_blank' v-if="sign_on==true && userstatus_info.last_learned_lesson_info.type == 'symposium'">-->
                    <!--<button class="btn course_side_base_btn join_in_course_button"-->
                    <!--v-if="userstatus_info.status==='active'">-->
                    <!--进入研讨-->
                    <!--</button>-->
                    <!--</a>-->
                    <a :href="'/courses/'+ userstatus_info.course_id +'/learning/?id='+userstatus_info.last_learned_lesson_id "
                       target='_blank' v-if="sign_on==true  && userstatus_info.last_learned_lesson_info.media_url">
                        <button class="btn course_side_base_btn join_in_course_button"
                                v-if="userstatus_info.status==='active'">
                            继续学习
                        </button>
                    </a>
                    <a :href="'/c/'+ userstatus_info.course_id +'/playback/?id='+userstatus_info.last_learned_lesson_id "
                       target='_blank' v-if="sign_on==true  && userstatus_info.last_learned_lesson_info.video_url">
                        <button class="btn course_side_base_btn join_in_course_button"
                                v-if="userstatus_info.status==='active'">
                            继续学习
                        </button>
                    </a>
                </div>
                <div v-else>
                    <!--<button v-if="is_applyed" class="btn course_side_base_btn applyed_course_button"-->
                    <!--@click="apply_course('cancel')" @mouseover="applyed_hover('enter')"-->
                    <!--@mouseout="applyed_hover('out')"-->
                    <!--&gt;{{applyed_then_exit}}-->
                    <!--</button>-->
                    <button v-if="is_applyed" class="btn course_side_base_btn applyed_course_button"
                    >{{applyed_then_exit}}
                    </button>
                </div>

                <!--<p class="task_count_p"> &nbsp;{{ course_info.labs_count }} 个模拟实训</p>-->
                <!--  这边用 v-if 判断是否有挑战,后端数据格式还没有确定，暂时不做任何事 -->
                <!-- <p></p> -->
                <div v-if="sign_on==false" class="follow_course_div">
                     <span class="follow_span"
                           @click="show_login('on')"
                     > 收藏</span>
                </div>
                <div v-else class="follow_course_div">
                     <span class="follow_span"
                           v-if="!userstatus_info.is_followed"
                           @click="_change_follow(true)"
                     > 收藏</span>
                    <span class="followed_span"
                          v-if="userstatus_info.is_followed"
                          @click="_change_follow(false)"
                    >已收藏</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import {mapState, mapActions} from 'vuex'
    import CourseTeacher from './course_teacher.vue'
    import Expense from '@/components/pay_page/expense.vue'
    import Pay from '@/components/pay_page/pay.vue'
    import courseApi from '@/api/courses/course_information.js'
    import accountApi from '@/api/account/account.js'
    import groupBuyApi from '@/api/group_buy/group_buy.js'

    export default {
        data: function () {
            return {
                fee_type_dict: {
                    'free': '免费',
                    'member': '加入会员免费'
                },
                nav_title: '购买',
                stuff_component_dict: {
                    '购买': 'Expense',
                    '充值': 'Pay'
                },
                dialogVisible: false,
                user_course_id: 0,
                is_applyed: false,
                applyed_then_exit: '已报名',
                dialogFormVisible: false,
                form: {
                    realname: '',
                    phone: '',
                    company: '',
                    job: '',
                    wechat_number: '',
                },
                rules: {
                    realname: [
                        {required: true, message: '请输入真实姓名', trigger: 'blur'},
                    ],
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号", trigger: "blur"}
                    ],
                    company: [
                        {required: true, message: '请输入单位名称', trigger: 'blur'},
                    ],
                    job: [
                        {required: true, message: '请输入岗位名称', trigger: 'blur'},
                    ],
                },
                formLabelWidth: '100px'

            }
        },
        components: {
            CourseTeacher,
            Expense,
            Pay
        },
        computed: {
            ...mapState({
                course_info: state => state.course.course_information,
                userstatus_info: state => state.course.course_userstatus[0],
                sign_on: state => state.loginState.sign_on,
                user_info: state => state.loginState.user_info
            }),
            user_all_copper_count: function () {
                return this.user_info.gold_count * 100 + this.user_info.silver_count * 10 + this.user_info.copper_count
            },
            expense_all_copper_count: function () {
                return this.course_info.price * 100
            },
            // need_count: function () {
            //     let need_count = {
            //         'gold_count': 0,
            //         'silver_count': 0,
            //         'copper_count': 0,
            //     }
            //     let course_all_count = this.course_info.price * 100
            //     let user_copper_count = this.login_user_coin_count.copper_count
            //     if (user_copper_count <= course_all_count) {
            //         need_count.copper_count = user_copper_count
            //     } else {
            //         need_count.copper_count = course_all_count
            //         return need_count
            //     }
            //     course_all_count -= need_count.copper_count
            //
            //     let user_silver_count = this.login_user_coin_count.silver_count
            //     if (user_silver_count * 10 <= course_all_count) {
            //         need_count.silver_count = user_silver_count
            //     } else {
            //         need_count.silver_count = course_all_count / 10
            //         return need_count
            //     }
            //     course_all_count -= need_count.silver_count * 10
            //
            //     let user_gold_count = this.login_user_coin_count.gold_count
            //     if (user_gold_count * 100 <= course_all_count) {
            //         need_count.gold_count = user_gold_count
            //     } else {
            //         need_count.gold_count = course_all_count / 100
            //         return need_count
            //     }
            //     course_all_count -= need_count.gold_count * 100
            //     return need_count
            //
            //
            // }
        },
        methods: {
            ...mapActions({
                change_follow: 'course/change_follow',
                join: 'course/join_course',
                show_login: 'loginState/change_show_state'
            }),
            apply_step_next() {
                // this.dialogFormVisible = false
                this.apply_course('apply')
            },
            tab_nav(nav_title) {
                this.nav_title = nav_title
            },
            to_buy(course_id) {
                courseApi.join_course({'id': course_id}).then((res) => {
                    if (res.data.code == 'success') {
                        this.user_course_id = res.data.user_course_id
                    }
                })
                this.dialogVisible = true
            },
            start_group_buy(course_id) {
                if (this.userstatus_info.group_buy_id){
                    this.$router.push({name: 'group_buy', params: {id: this.userstatus_info.group_buy_id}})
                }else{
                    let args = {
                        'course_id': course_id
                    }
                    groupBuyApi.start_group_buy(args).then(res => {
                        console.log(res)
                        let data = JSON.parse(res.data.result)
                        if (data.code == 'success') {
                            this.$router.push({name: 'group_buy', params: {id: data.group_buy_id}})
                        } else {
                            this.$message({
                                message: data.message,
                                type: 'warning'
                            });
                        }
                    })
                }

            },

            _change_follow: function (isFollow) {
                let id = this.$route.params.id
                this.change_follow({
                    'is_follow': isFollow,
                    'id': id
                })
            },
            join_course: function () {
                this.join({
                    id: this.$route.params.id
                })
            },
            _apply_course() {
                let course_id = this.$route.params.id;
                courseApi.get_course_applyed({'course_id': course_id}).then((res) => {
                    this.form = res.data.form
                })
                this.dialogFormVisible = true
            },
            apply_course(type) {
                let course_id = this.$route.params.id;
                if (type == 'apply') {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            courseApi.apply_course({
                                'course_id': course_id,
                                'type': 'apply',
                                'form': this.form
                            }).then((res) => {
                                let data = JSON.parse(res.data.result)
                                if (data.code == 'success') {
                                    if (this.course_info.fee_type === 'free') {
                                        this.is_applyed = true
                                        this.$message({
                                            message: data.message,
                                            type: 'success'
                                        });
                                        this.dialogFormVisible = false
                                    } else {
                                        this.to_buy(this.course_info.id)
                                        
                                        // this.dialogVisible = true
                                    }
                                }

                            })
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                } else if (type == 'cancel') {
                    courseApi.apply_course({'course_id': course_id, 'type': 'cancel'}).then((res) => {
                        let data = JSON.parse(res.data.result)
                        if (data.code == 'success') {
                            this.is_applyed = false
                            this.$message({
                                message: data.message,
                                type: 'success'
                            });
                        }
                    })
                }
            },
            applyed_hover(type) {
                if (type == 'enter') {
                    this.applyed_then_exit = '取消报名'
                } else {
                    this.applyed_then_exit = '已报名'
                }
            },
            join_paid_course() {
                this.$message({
                    showClose: true,
                    message: '系统正在建设中，请联系管理员',
                    type: 'warning'
                });
            }
        },
        mounted() {
            let course_id = this.$route.params.id;
            courseApi.get_course_applyed({'course_id': course_id}).then((res) => {
                this.is_applyed = res.data.is_applyed
            })

        }
    }
</script>
<style type="text/css" scoped>
    .nav_title_ul {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_title_li {
        font-size: 16px;
        padding: 3px 5px;
        padding-bottom: 7px;
        margin-right: 25px;
        margin-bottom: -1px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .active_nav {
        border-bottom-color: #66CCFF;;
    }

    .course_side_content_div {
        margin-left: 15px;
        width: 315px;
        background: #fff;
    }

    .course_info_img {
        padding: 5px 5px 0;
        width: 100%;
    }

    .course_info_box {
        padding: 1rem 1rem 5px;
        font-size: 16px;
        font-weight: 500;
        color: #333;
    }

    .course_side_base_btn {
        width: 100%;
        padding-top: 12px;
        padding-bottom: 12px;
        box-shadow: none;
    }

    .join_in_course_button {
        color: #fff;
        background-color: #66CCFF;
        border-color: #66CCFF;
    }

    .join_in_course_button:hover {
        color: #fff;
        background-color: #069a75;
        border-color: #068e6c;
    }

    .join_member_button {
        color: #fff;
        background-color: #ff9c4a;
        border-color: #ff9c4a;
    }

    .join_member_button:hover {
        color: #fff;
        background-color: #ff8017;
        border-color: #ff8017;
    }

    .buy_course_button {
        color: #fff;
        background-color: #f66;
        border-color: #f66;
    }

    .buy_course_button:hover {
        color: #fff;
        background-color: #f33;
        border-color: #ff2626;
    }

    .apply_course_button {
        color: #fff;
        background-color: #ff9750;
        border-color: #ff9750;
    }

    .apply_course_button:hover {
        color: #fff;
        background-color: #ff9720;
        border-color: #ff9720;
    }

    .applyed_course_button {
        color: #fff;
        background-color: #66CCFF;
        border-color: #66CCFF;
    }

    .applyed_course_button:hover {
        color: #fff;
        background-color: #f33;
        border-color: #f33;
    }

    .task_count_p {
        margin-top: 15px;
        font-size: 14px;
        color: #a4a4a4;
    }

    .task_count_p:before {
        content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAURJREFUOBFjYBhowAhywIkTJ2L//fvXy8jIyE2kg34A1TVYWlpOBhtw/PjxtywsLPampqZXiDHgzJkzkr9//74iISEhzQTVwEGsZpB6ExOT50Dq5du3b3lgBkDNIZ1iQddy48YN3g8fPgT8////DDBMGIF0MpDaAcRsZmZm24H0P2Q9KC44duyYyvv37xcANb0BBtB1IB0FVHzK3Nx8DzCQDYCBXYmsGcRGMYCfn/8FUOw70BY1YEDxA9nWfHx8W8+ePcsJZKsA8R8gRgEoBmhra3+xsLCIB9p8BoiVgDgPJPbnzx89JiamEqCrOlF0AzkYYQC0/S9Q/CiyQqChJ5D5yGwUFyBLEGIDXcf069evfzAXnAQGYDvQ9tOENILkgeoUgQb8BHrpHdgAYED5ffr0KQYop0WMAcAY+QBU50iMWtqrAQClMXrxPbjrawAAAABJRU5ErkJggg==);
        vertical-align: middle;
    }

    .follow_course_div {
        margin-top: 50px;
        padding-top: 15px;
        border-top: 1px solid #eee;
        text-align: center;
        color: #a4a4a4;
    }

    .follow_span:before {
        content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAc9JREFUOBGtVE2rQVEUXVcPZeBzruSjEGIqZehPGvglRlIUSYjI15R8xEi5z9qvc3tc7977Xm/V6e69z9rr7MPeR9MfwD/C5URrPB6Dywk+7Ejz+RzdbldoHo8HiUTCMsVWsN/vI5vNightO0HLK69WK1wuF+RyOVm0GbOCpSArymQy8Hq9stLpNBizgnHl+/2O8/ks63g8Yr/f43A4oFarGfn5fB6j0QjNZhORSATBYBB+v1+Wy/VVm8a2abVamEwmoKjb7UYgEBBSNBpFKpUyBGlMp1Nst1ucTic5/Ha7gWKsvlwuAxRsNBp6u93Wr9cr3V+BOcylBiF1VioV6bPdbvdUjROHOexRaghUOYvFQq/X6/p6vVYh2y+5zGGuglxZOb8RfSdGnSdBBh7ly6mPP4juW3CPlZH7ClMfcrx8Ph80TfvxJ+QeOeS+wiTI3guFQq88k08Oua8wGlttkBQOh5UL9tlgMBC/UChIn9Ihx7FgLBaTJudUcNRUxWyPYrEojwVjy+XSOFgZpgr5AHDs+GRxaqrVKjgxxGazQafTwXA4RDwel4dDCamvjJ5y+O31epLIJyuZTH7fMuzZbCbNzINKpZIRp2ESfNr9g/MJ9WrieGiQzqYAAAAASUVORK5CYII=);
        vertical-align: middle;
    }

    .followed_span:before {
        content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAapJREFUOBHVlL9LQlEUx895Sjj0D+iaFpUNEc1BEdTSEA0NranPqbGG4k1RBGGD+IP2aIhoaW+NBqFoUBqiINGgaEyfp+995kN99jSX6IKec8/53s+5P44S/cWQaDQjur7YS23uJgJoikzzhpjvye+fYMOoua3R3JJWzjR3LCsyRsXiSje9K1BisUkAlmyIyLaIuJ7KFUgA2DDliIRJ15dbYm0Tu5rE44PIBalWG4YNwY7AruFja+Bjxk8AX8ArwM/DL1Ag8Ii7rVpp9SWRyDXMtPL7HBXANzmTOawfWdP2Aar0CVPLHrDTE+VYQE6nz8jjUS/4qYK/Gsx3pGkznM2+qHUt94MGXkClc8R9PUJz0M0D9trQtwBVENA5QC/hDjREP9gcTjXLqdRbc97ZNn7/VbPAxb9thymtE1gqhRDvtjvVPuFOxZzAarWj0LFYZFQMw7HeEXBUZi4itgHgMazVvN9wH5XLwfZCTiBRfYfM6rK38EBDaNgjvOQ6eb3jgJ4iLhaow2m87RUAeEZf7ZLPd8CJxHtznpPJPOar+Jnu4S/NgO6jOf8//C8DrX88kmxjGQAAAABJRU5ErkJggg==);
        vertical-align: middle;
    }

    .bootcamp_info_layout {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        position: relative;
    }

    .member_price_card {
        position: absolute;
        display: none;
        box-shadow: 0 3px 16px 0 rgba(0, 0, 0, .18);
        padding: 3px 10px;
        background: #fff;
    }

    .bootcamp_price {
        color: #f66;
        font-weight: 700;
        font-size: 16px;
    }

    .bootcamp_angle {
        cursor: pointer;
        transition: transform .3s ease-out;
        transition: transform .3s ease-out, -webkit-transform .3s ease-out;
        color: #6c757d;
    }

    .member_dict_layout {
        margin-bottom: 1rem;
    }

    .member_dict_layout:hover .bootcamp_angle {
        transform: rotate(180deg);
    }

    .member_dict_layout:hover .member_price_card {
        display: block;
    }

    .bootcamp_member_info {
        display: flex;
        justify-content: space-between;
        background: #f9f9f9;
        padding: 4px 8px;
        font-size: 12px;
        margin-bottom: 1rem;
    }

    .go_for_purchase {
        color: #fd8c51;
    }

    .go_for_purchase:hover {
        color: #fd8c51;
        text-decoration: underline !important;
    }

</style>
